/** 개인 설정: 화면 테마 */
import { z } from "zod";

export const THEMES = [
  { id: "system", name: "소나무", note: "기기 설정에 따라 밝게·어둡게", dark: null },
  { id: "pine-light", name: "소나무 밝게", note: "늘 밝게", dark: false },
  { id: "pine-dark", name: "소나무 어둡게", note: "늘 어둡게", dark: true },
  { id: "nord", name: "노르드", note: "Polar Night 바탕, Frost 강조", dark: true },
  { id: "nord-deep", name: "노르드 딥", note: "더 깊은 밤", dark: true },
  { id: "nord-aurora", name: "노르드 오로라", note: "어두운 바탕, Aurora 초록 강조", dark: true },
  { id: "nord-light", name: "노르드 라이트", note: "Snow Storm 바탕", dark: false },
  { id: "nord-frost", name: "노르드 프로스트", note: "밝은 바탕, 어두운 사이드바", dark: false },
  { id: "terra", name: "테라", note: "흙빛 밝은 바탕, 테라코타 강조", dark: false },
  { id: "terra-dark", name: "테라 어둡게", note: "짙은 흙빛, 구운 점토 강조", dark: true },
] as const;

export type ThemeId = (typeof THEMES)[number]["id"];
export const THEME_IDS = THEMES.map((t) => t.id) as [ThemeId, ...ThemeId[]];

export interface Preferences {
  theme: ThemeId;
}
export const DEFAULT_PREFERENCES: Preferences = { theme: "system" };

export const preferencesInput = z.object({ theme: z.enum(THEME_IDS) });
